import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "@i18n";
import { Link, useParams } from "react-router-dom";
import { qs } from "url-parse";
import Layout from "@/_LayoutsRelated/layout/Layout";
import Button from "../../../components/UiKit/Button/Button";
import Disclaimer from "@/_MiniApps/Disclaimer/Disclaimer";
import stl from "./PreCheckout.module.css";
import { cashCheckout1Event, finanaceButtonClickedEvents } from "@/utils/dataLayerEvents";
import PaymentInfoV2 from "@/pages/checkout/components/PaymentInfo/PaymentInfoV2";
import { trackEvents } from "@/common/events/events";
import { useIsMobile } from "@/common/Contexts/IsMobileContext";
import CancelButton from "../../../components/UiKit/Buttons/CancelButton/CancelButton";
import useHelpers from "@hooks/useHelpers";
import Loader from "@componentsShared/Loader/Loader";
import { api__tabbyPreScoring } from "@/apis/tabby/tabby";
import { PURCHASE_METHOD_AMWAL, PURCHASE_METHOD_ARIB, PURCHASE_METHOD_CASH, PURCHASE_METHOD_CREDIT_CARD, PURCHASE_METHOD_NORMAL_FINANCE, PURCHASE_METHOD_TABBY, PURCHASE_METHOD_TAMRA, useCheckoutOrder } from "@/common/Contexts/CheckoutOrderContext";
import PreCheckoutPurchaseMethodsV2 from "@/pages/checkout/pre-checkout/PreCheckoutPurchaseMethodsV2";
import BoxLoading from "@componentsShared/placeholders/BoxLoading/BoxLoading";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import { CDN_LINK } from "@globalConfig";
import useBoolean from "@hooks/useBoolean";
import PreCheckoutFAQs from "@/pages/checkout/pre-checkout/PreCheckoutFAQs";
import useSticky from "@hooks/useSticky";
import { twMerge } from "tailwind-merge";
import { useSession } from "@/_MiniApps/auth/AuthContext";
var PreCheckout = function PreCheckout() {
  var _checkoutOrderV2$post2, _checkoutOrderV2$post3, _checkoutOrderV2$deta, _checkoutOrderV2$mult2, _checkoutOrderV2$deta2, _checkoutOrderV2$fina, _checkoutOrderV2$post4, _checkoutOrderV2$post5, _checkoutOrderV2$g4_d, _checkoutOrderV2$stor, _checkoutOrderV2$stor2;
  if (__IS_SSR__) return /*#__PURE__*/React.createElement(Loader, null);
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo,
    navigateBack = _useHelpers.navigateBack,
    navigateToHard = _useHelpers.navigateToHard;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var isMobile = useIsMobile();
  var isDesktop = !isMobile;
  var _useParams = useParams(),
    post_id = _useParams.postId;
  var _useState = useState(null),
    event = _useState[0],
    setEvent = _useState[1];
  var _useCheckoutOrder$sta = useCheckoutOrder().state,
    checkoutOrderV2 = _useCheckoutOrder$sta.checkoutOrderV2,
    fetch_loading = _useCheckoutOrder$sta.fetch_loading,
    showCampaignModal = _useCheckoutOrder$sta.showCampaignModal;
  var purchaseMethod = useCheckoutOrder().state.purchaseMethod;
  var fetch__getOrderWithPaymentInfoV2 = useCheckoutOrder().remote_actions.fetch__getOrderWithPaymentInfoV2;
  var _useCheckoutOrder$act = useCheckoutOrder().actions,
    action__setPurchaseMethod = _useCheckoutOrder$act.action__setPurchaseMethod,
    action__setShowCampaignModal = _useCheckoutOrder$act.action__setShowCampaignModal;
  var grantedPopup = useBoolean();
  var _useHelpers2 = useHelpers(),
    createUrl = _useHelpers2.createUrl;
  var _useSession = useSession(),
    user = _useSession.user,
    isLoggedIn = _useSession.isLoggedIn;
  var _useState2 = useState(null),
    tabbyEligible = _useState2[0],
    setTabbyEligible = _useState2[1];
  var _useState3 = useState(null),
    tabbyRejectionMessage = _useState3[0],
    setTabbyRejectionMessage = _useState3[1];
  var stickyRef = useRef(null);
  var isComponentSticky = useSticky(stickyRef);
  useEffect(function () {
    fetch__getOrderWithPaymentInfoV2(Number(post_id));
  }, [post_id]);
  useEffect(function () {
    var _checkoutOrderV2$mult, _checkoutOrderV2$post;
    var bnplOptions = (_checkoutOrderV2$mult = checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : checkoutOrderV2.multipleFinanceTypesPreCheckoutScreen) !== null && _checkoutOrderV2$mult !== void 0 ? _checkoutOrderV2$mult : [];
    var hasTabbyOption = bnplOptions.some(function (o) {
      return o.type === 'dynamic_finance' && o.finance_type_en === 'tabby';
    });
    if (!hasTabbyOption || !(checkoutOrderV2 !== null && checkoutOrderV2 !== void 0 && (_checkoutOrderV2$post = checkoutOrderV2.post) !== null && _checkoutOrderV2$post !== void 0 && _checkoutOrderV2$post.post_id)) return;
    if (!isLoggedIn) {
      setTabbyEligible(true);
      return;
    }
    api__tabbyPreScoring({
      post_id: Number(checkoutOrderV2.post.post_id),
      phone_number: user.phone_number
    }).then(function (res) {
      if (res.data.rejection_reason) {
        setTabbyEligible(false);
        setTabbyRejectionMessage(res.data.message);
      } else {
        setTabbyEligible(true);
      }
    })["catch"](function () {
      setTabbyEligible(true);
    });
  }, [checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$post2 = checkoutOrderV2.post) === null || _checkoutOrderV2$post2 === void 0 ? void 0 : _checkoutOrderV2$post2.post_id, isLoggedIn, user === null || user === void 0 ? void 0 : user.phone_number]);
  var handleContinue = function handleContinue() {
    switch (purchaseMethod) {
      case PURCHASE_METHOD_CASH:
        return navigateTo("/checkout/shop-apply?post_id=".concat(post_id));
      case PURCHASE_METHOD_CREDIT_CARD:
        return navigateTo("/checkout/credit-card?post_id=".concat(post_id));
      case PURCHASE_METHOD_NORMAL_FINANCE:
        return navigateTo("/finance-apply-free/".concat(post_id, "?").concat(qs.stringify({
          financestep: 1
        })));
      case PURCHASE_METHOD_TAMRA:
        return navigateTo("/finance-apply-tamara?post_id=".concat(post_id));
      case PURCHASE_METHOD_ARIB:
        return navigateTo('/finance-apply-arib', {
          post_id: post_id
        });
      case PURCHASE_METHOD_TABBY:
        return navigateTo("/finance-apply-tabby?post_id=".concat(post_id));
      case PURCHASE_METHOD_AMWAL:
        return navigateTo("/finance-apply-amwal?post_id=".concat(post_id));
      default:
        return;
    }
  };
  return /*#__PURE__*/React.createElement(Layout, {
    hideBurgerMenu: isMobile,
    hideFooter: true,
    hideOrangeHeadBtn: true,
    headHideLinks: true,
    hideAppBanner: true,
    straightHeader: true,
    hideHeaderOnmobile: true,
    custommobileHeader: /*#__PURE__*/React.createElement("div", {
      className: stl.mobileHeader
    }, /*#__PURE__*/React.createElement("strong", {
      className: "!text-black-primary text-center"
    }, tShort("pre-checkout/mobile_page_title", {
      ns: "web_pre_checkout"
    })), /*#__PURE__*/React.createElement(CancelButton, {
      isArrow: true,
      onClick: navigateBack,
      className: "".concat(stl.CancelButton, " !text-primary-new")
    }))
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.container, " container")
  }, isMobile && /*#__PURE__*/React.createElement("div", {
    className: stl.mobileCarName
  }, /*#__PURE__*/React.createElement("strong", {
    className: ""
  }, fetch_loading && /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 24,
    divWidth: 150
  }), /*#__PURE__*/React.createElement(Link, {
    id: "precheckout-car-name",
    to: createUrl("/cardetail/".concat(post_id)),
    className: "font-bold text-sm text-gray-text underline hover:text-gray-text"
  }, checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$post3 = checkoutOrderV2.post) === null || _checkoutOrderV2$post3 === void 0 ? void 0 : _checkoutOrderV2$post3.post_title)), /*#__PURE__*/React.createElement("strong", null, fetch_loading && /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 24,
    divWidth: 80
  }), !fetch_loading && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "precheckout-car-price",
    className: "flex items-center gap-1"
  }, /*#__PURE__*/React.createElement("span", {
    className: "font-bold text-gray-text text-1.5xl"
  }, checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$deta = checkoutOrderV2.detail) === null || _checkoutOrderV2$deta === void 0 ? void 0 : _checkoutOrderV2$deta.sale_price), /*#__PURE__*/React.createElement("span", null, t("sar", {
    ns: "web_common"
  })))))), /*#__PURE__*/React.createElement("div", {
    className: stl.flxContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.subBox
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid lg:w-[664px] lg:shadow-[0_0px_10px_rgb(188,188,188,0.4)] lg:rounded-2xl lg:box-border lg:p-[42px] lg:bg-white md:!pt-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: [stl.title, 'hidden md:block md:!mb-6 text-black-primary text-xl'].join(" ")
  }, t("choose_purchase_method", {
    ns: "web_pre_checkout"
  })), /*#__PURE__*/React.createElement(PreCheckoutPurchaseMethodsV2, {
    methods: (_checkoutOrderV2$mult2 = checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : checkoutOrderV2.multipleFinanceTypesPreCheckoutScreen) !== null && _checkoutOrderV2$mult2 !== void 0 ? _checkoutOrderV2$mult2 : [],
    loading: fetch_loading,
    salePrice: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$deta2 = checkoutOrderV2.detail) === null || _checkoutOrderV2$deta2 === void 0 ? void 0 : _checkoutOrderV2$deta2.sale_price,
    financeSteps: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$fina = checkoutOrderV2.finance) === null || _checkoutOrderV2$fina === void 0 ? void 0 : _checkoutOrderV2$fina.financeSteps,
    postIsNew: !!(checkoutOrderV2 !== null && checkoutOrderV2 !== void 0 && (_checkoutOrderV2$post4 = checkoutOrderV2.post) !== null && _checkoutOrderV2$post4 !== void 0 && _checkoutOrderV2$post4.post_is_new),
    postId: checkoutOrderV2 !== null && checkoutOrderV2 !== void 0 && (_checkoutOrderV2$post5 = checkoutOrderV2.post) !== null && _checkoutOrderV2$post5 !== void 0 && _checkoutOrderV2$post5.post_id ? Number(checkoutOrderV2.post.post_id) : undefined,
    g4Data: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d === void 0 ? void 0 : _checkoutOrderV2$g4_d.g4_data_layer,
    cashStory: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$stor = checkoutOrderV2.story) === null || _checkoutOrderV2$stor === void 0 ? void 0 : (_checkoutOrderV2$stor2 = _checkoutOrderV2$stor.story_section) === null || _checkoutOrderV2$stor2 === void 0 ? void 0 : _checkoutOrderV2$stor2.cash_story,
    tabbyEligible: tabbyEligible,
    tabbyRejectionMessage: tabbyRejectionMessage,
    isLoggedIn: isLoggedIn
  }), isMobile && /*#__PURE__*/React.createElement(PreCheckoutFAQs, null), /*#__PURE__*/React.createElement("div", {
    ref: stickyRef,
    className: twMerge("sticky bottom-0 left-0 bg-white p-4 rounded-lg w-auto mx-[-16px] md:relative md:p-0 md:rounded-none md:mx-0", isComponentSticky ? "shadow-[0px_0px_12px_0px_rgba(0,0,0,0.15)] md:shadow-none" : "shadow-none")
  }, /*#__PURE__*/React.createElement(Button, {
    id: "precheckout-proceed-btn",
    onClick: function onClick() {
      var _checkoutOrderV2$g4_d2, _checkoutOrderV2$g4_d3, _checkoutOrderV2$g4_d4, _checkoutOrderV2$g4_d5, _checkoutOrderV2$g4_d6;
      var booking_type = null;
      if (purchaseMethod === PURCHASE_METHOD_CASH) {
        booking_type = "cash";
      } else if (purchaseMethod === PURCHASE_METHOD_NORMAL_FINANCE) {
        booking_type = "finance";
      } else if (purchaseMethod === PURCHASE_METHOD_ARIB) {
        booking_type = 'finance';
      } else if (purchaseMethod === PURCHASE_METHOD_TAMRA) {
        booking_type = "tamara";
      } else if (purchaseMethod === PURCHASE_METHOD_TABBY) {
        booking_type = "tabby";
      } else if (purchaseMethod === PURCHASE_METHOD_AMWAL) {
        booking_type = "amwal";
      } else if (purchaseMethod === PURCHASE_METHOD_CREDIT_CARD) {
        booking_type = "credit_card";
      }
      trackEvents("checkout", _objectSpread(_objectSpread({}, checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d2 = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d2 === void 0 ? void 0 : _checkoutOrderV2$g4_d2.g4_data_layer), {}, {
        booking_type: booking_type,
        post_trim: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d3 = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d3 === void 0 ? void 0 : (_checkoutOrderV2$g4_d4 = _checkoutOrderV2$g4_d3.g4_data_layer) === null || _checkoutOrderV2$g4_d4 === void 0 ? void 0 : _checkoutOrderV2$g4_d4.post_ext,
        from_finance_calculator: false,
        inventory_type_string: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d5 = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d5 === void 0 ? void 0 : (_checkoutOrderV2$g4_d6 = _checkoutOrderV2$g4_d5.g4_data_layer) === null || _checkoutOrderV2$g4_d6 === void 0 ? void 0 : _checkoutOrderV2$g4_d6.inventory_type_string
      }));
      if (event === "finance") {
        var _checkoutOrderV2$g4_d7;
        finanaceButtonClickedEvents(null, checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d7 = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d7 === void 0 ? void 0 : _checkoutOrderV2$g4_d7.g4_data);
      } else {
        var _checkoutOrderV2$g4_d8;
        cashCheckout1Event("checkout_lead", checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d8 = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d8 === void 0 ? void 0 : _checkoutOrderV2$g4_d8.g4_data);
      }
      handleContinue();
    },
    className: stl.btn,
    isDisabled: !purchaseMethod
  }, t("next", {
    ns: "web_common"
  }))), !isMobile && /*#__PURE__*/React.createElement(PreCheckoutFAQs, null))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "m-show mt-10"
  }, /*#__PURE__*/React.createElement(Disclaimer, {
    className: stl.Disclaimer
  }))), isDesktop && /*#__PURE__*/React.createElement("div", {
    id: "precheckout-finance-info",
    className: stl.subBox2
  }, /*#__PURE__*/React.createElement(PaymentInfoV2, {
    checkoutOrderV2: checkoutOrderV2,
    loading: fetch_loading,
    onClickInfoIcon: grantedPopup.setTrue
  })))), isDesktop && /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: grantedPopup.value,
    onClose: grantedPopup.setFalse,
    containerClassName: "!z-[999999999]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center gap-8 p-[13px]"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/infoOrange.svg",
    width: "96px",
    height: "82px",
    alt: "icon"
  }), /*#__PURE__*/React.createElement("strong", {
    className: "text-blue-indigo text-center text-[32px] font-bold leading-[32px]"
  }, t("shipping_cost_2", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-blue-indigo text-center font-[Cairo] text-[20px] font-semibold leading-[32px]"
  }, t("shipping_cost_determined_sales_representative", {
    ns: "web_checkout_cash"
  })))));
};
export default PreCheckout;